module.exports = __webpack_public_path__ + "img/loader.79a9eae3.gif";